import { render, staticRenderFns } from "./CaratSelectionView.vue?vue&type=template&id=36bbdbf6&"
import script from "./CaratSelectionView.vue?vue&type=script&lang=js&"
export * from "./CaratSelectionView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports